import { appStore } from '../../app/AppStore';
import { hasRunNowPermission } from '../../app/utils/MixedContentHelpers';
import { L10n } from '../L10n/L10n';
import { IDataSourceInfo } from '../models/IDataSourceInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { CreateExtractTasksAction, ICreateExtractTasksScope } from '../services/CreateExtractTasksAction';
import { Messages, Formatters } from '../../codegen/Localize';

interface CreateDatasourceExtractRefreshScope extends ICreateExtractTasksScope {
  datasource: IDataSourceInfo;
  allowedMode: string;
}

Module.instance().directive('tbDatasourceExtractRefreshScheduler',
  ['CreateExtractTasksAction',

    (CreateExtractTasksAction: CreateExtractTasksAction) => {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          datasource: '=',
          allowedMode: '@',
          extractTask: '='
        },
        templateUrl: 'confirmActionDialogExtractRefresh.html',
        link: (scope: CreateDatasourceExtractRefreshScope) => {
          const scheduleOnServerPrompt = Messages.schedulesLabelPromptDatasource({ DATASOURCE_NAME: L10n.elideIfLong(scope.datasource.name) });
          const scheduleOnClientPrompt = Messages.schedulesLabelPromptDatasourceOnClient({ DATASOURCE_NAME: L10n.elideIfLong(scope.datasource.name) });

          const DATASOURCE_COUNT = 1;
          const refreshNowPrompt = !hasRunNowPermission(appStore.getState())
            ? Messages.extractTasksRefreshNowDisabled()
            : Messages.extractTasksRefreshNowOnDatasourcesPrompt({
                DATASOURCE_COUNT,
                DATASOURCE_NAME: L10n.elideIfLong(scope.datasource.name),
                DATASOURCE_COUNT_LOC: Formatters.formatCount(DATASOURCE_COUNT)
            });

          const datasourceSet = Set.singleton(scope.datasource, (ds: IDataSourceInfo) => ds.id);

          CreateExtractTasksAction.populateScope(scope, datasourceSet, scheduleOnServerPrompt, scheduleOnClientPrompt, parseInt(scope.allowedMode, 10), refreshNowPrompt);
        }
      };
    }
  ]
);
